export default function routesConfig(page) {
  switch (page) {
    case 'services-status':
      return '/:type/services-status'
    case 'subscriptions-list-telesales':
      return '/:type/subscription/list/overview'
    case 'subscriptions-list-websales':
      return '/:type/subscription/list/websales'
    case 'telesales-form':
      return '/:type/subscription/*'
    case 'telesales-form-v2':
      return '/contact/*'
    case 'dev-tools':
      return '/:type/dev-tools/tools'
    case 'dev-tools-v2':
      return '/dev-tools-v2/*'
    case 'client-callbacks':
      return '/callbacks'
    case 'assistance-management':
      return '/:type/additional-sales/assistance'
    case 'mon-conseiller-perso-management':
      return '/:type/additional-sales/mon-conseiller-perso'
    case 'carbon-offset':
      return '/:type/additional-sales/carbon-offset'
    case 'organizations-management':
      return '/:type/organisations/provider/*'
    case 'comparator-management':
      return '/organisations/comparator/*'
    case 'provider-options':
      return '/:type/provider-options/*'
    case 'additional-products-management':
      return '/additional-sales/*'
    case 'users-management':
      return '/users-mngt/*'
    case 'ip-addresses-management':
      return '/ip-addresses-management/*'
    case 'offices-management':
      return '/:type/offices/*'
    case 'contracts-list':
      return '/:type/contracts'
    default:
      return '/:type'
  }
}
